import React from "react";
import { Container, Row, Col } from "shards-react";
import Invoice from "../components/invoicing/Invoice";

const InvoinceView = props => {
  const { id } = props.match.params;

  const query = new URLSearchParams(props.location.search);
  const client_id = query.get("client") ? query.get("client") : 0;
  const booking_id = query.get("booking") ? query.get("booking") : 0;
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <Invoice id={id} client_id={client_id} booking_id={booking_id} />
        </Col>
      </Row>
    </Container>
  );
};

export default InvoinceView;
